import Styled from 'styled-components';

const H1 = Styled.h1`
  font-size: 15px;
  font-weight: 600;
  line-height: 38px;
`;

const H2 = Styled.h2`
  font-size: 15px;
  font-weight: 600;
  line-height: 30px;
`;

const H3 = Styled.h3`
  font-size: 15px;
  font-weight: 600;
  line-height: 27px;
`;

const H4 = Styled.h4`
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
`;

const H5 = Styled.h5`
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
`;

const H6 = Styled.h6`
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
`;

export { H1, H2, H3, H4, H5, H6 };
